<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="true"
        class="ah-detail-dialog payment-modify-accno-dialog"
        top="15vh"
        append-to-body
        :lock-scroll="false"
        :before-close="onClose"
        @open="onOpen"
    >
        <template slot="title">修改付款立帳科目</template>
        <div v-if="!isSubmited" class="detail-row">
            <el-form ref="form" :model="form" :rules="rules" label-position="top" v-loading="isIniting">
                <el-form-item>
                    <template slot="label">支出項目</template>
                    <div v-if="statementItemData" class="statement-item-name">{{ getHierarchyItemNames(statementItemData.sno) }}</div>
                </el-form-item>
                <el-form-item prop="accno">
                    <template slot="label">付款立帳科目<ah-tip>可選項目設定於「會計科目對照表」。</ah-tip></template>
                    <el-select ref="accnoSelect" v-model="form.accno" name="accno" no-data-text="無歸屬會計科目" style="width: 100%" :disabled="isIniting">
                        <el-option v-for="item in accnoOptions" :key="item.sno" :label="`${item.accno} - ${item.accnam}`" :value="item.accno" class="accno-option">
                            <div class="accno-text">{{ item.accno }} - {{ item.accnam }}</div>
                            <div class="sub-text">{{ item.mem }}</div>
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div v-if="!isIniting" style="padding: 10px 0; text-align: right">
                <el-button icon="el-icon-close" :disabled="isIniting" @click="onClose">取消</el-button>
                <el-button type="primary" icon="el-icon-check" :disabled="isIniting || !form.accno" @click="onSubmit" :loading="isSubmitting">送出修改</el-button>
            </div>
        </div>
        <div v-if="isSubmited" class="detail-row">
            <div v-if="submitedAccItem">
                <div style="text-align: center; padding: 20px; color: #009e00">
                    <i class="el-icon-check" style="font-size: 30px"></i>
                    <div style="font-weight: bold">修改成功</div>
                </div>
                <div style="padding: 10px 0">付款立帳科目已修改為：</div>
                <div class="acc-item-name">{{ submitedAccItem.accno }} - {{ submitedAccItem.accnam }}</div>
            </div>
            <div style="padding: 40px 0 10px 0; text-align: right">
                <el-button icon="el-icon-close" @click="onClose">知道了，關閉</el-button>
                <el-button v-if="isAbleToOperateVoucher" type="primary" icon="el-icon-refresh" @click="onRegenerateVouchers">用新科目重新產生傳票</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        typ: {
            // 1: 發票, 2: 請款單, 3: 財務單
            type: Number,
            default: null,
        },
        visible: {
            type: Boolean,
            default: false,
        },
        unT_NBR: {
            type: String,
            default: null,
        },
        itemSno: {
            // 請款單支出項目
            type: Number,
            default: null,
        },
        accno: {
            // 請款單付款立帳會計科目
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isIniting: false,
            isSubmitting: false,
            isSubmited: false,
            accountingItems: [], // 所有會計科目
            accnoOptions: [], // 下拉選單項目
            statementItemData: null, // 支出項目資料
            form: {
                accno: '',
            },
            rules: {
                accno: [{ required: true, message: '請選擇會計科目', trigger: 'change' }],
            },
            submitedAccItem: null,
        };
    },
    computed: {
        statementOptions() {
            return this.$store.getters['statement/statementOptions'];
        },

        userGrP_NO() {
            return this.$store.getters['account/userGrP_NO'];
        },
        isSAAdmin() {
            return this.$store.getters['account/isSAAdmin'];
        },
        isAbleToOperateVoucher() {
            return this.userGrP_NO === 'OT1' || this.userGrP_NO === 'OT2' || this.userGrP_NO === 'OT3' || this.userGrP_NO === 'OT4' || this.isSAAdmin;
        },
    },
    methods: {
        async onOpen() {
            this.accnoOptions = [];
            this.isIniting = true;

            // store 更新最新會計項目對照表
            await this.$store.dispatch('statement/updateStatementOptions');

            // 重新載入所有會計科目清單
            await this.fetchAccountingItems();

            // 製作下拉單項目
            this.accnoOptions = this.getAccnoOptions();
            this.form.accno = this.accno;
            this.isIniting = false;

            this.$nextTick(() => {
                this.$refs.accnoSelect.focus();
                this.$refs.form.clearValidate(); // 開啟對話框後清除驗證狀態，避免之前的驗證錯誤訊息還在
            });
        },
        onClose() {
            this.$emit('close', this.isSubmited);
            this.isSubmited = false;
            this.isIniting = false;
            this.isSubmitting = false;
            this.form.accno = '';
            this.accnoOptions = [];
            this.statementItemData = null;
            this.submitedAccItem = null;
            this.$nextTick(() => {
                this.$refs.form.clearValidate(); // 關閉對話框後清除驗證狀態，避免下次開啟還有之前的驗證錯誤訊息
            });
        },
        getAccnoOptions() {
            // 要回傳的下拉單科目清單
            const options = [];

            // 取得舊有立帳 accno 的會計科目資料
            const oldAccItem = this.getAccountingItemByAccno(this.accno);
            if (oldAccItem) {
                options.push({
                    accnam: oldAccItem.accnam,
                    accno: oldAccItem.accno,
                    sno: oldAccItem.sno,
                    mem: '原始付款的立帳科目',
                });
            }

            // 取得當前收支項目資料（項目可能已被刪除，找不到時 statementItem 會是 null）
            const statementItem = this.getStatementItemBySno(this.itemSno);
            this.statementItemData = statementItem;

            if (statementItem) {
                // 取得最新的對照主會計科目（與舊有 accno 不一樣才加入列表）
                const latestAccItem = this.getAccountingItemByAccno(statementItem.accno);
                if (oldAccItem && latestAccItem && latestAccItem.accno !== oldAccItem.accno) {
                    options.push({
                        accnam: latestAccItem.accnam,
                        accno: latestAccItem.accno,
                        sno: latestAccItem.sno,
                        mem: '支出項目已變更後的會計科目',
                    });
                } else if (!oldAccItem && latestAccItem) {
                    options.push({
                        accnam: latestAccItem.accnam,
                        accno: latestAccItem.accno,
                        sno: latestAccItem.sno,
                        mem: '支出項目對應的會計科目',
                    });
                }

                // 取得最新的其他建議科目
                statementItem.suggestedAccItems.forEach((sugAccItem) => {
                    // 跳過與舊有 accno 相同的項目
                    if (oldAccItem && sugAccItem.accno === oldAccItem.accno) return;

                    options.push({
                        accnam: sugAccItem.accnam,
                        accno: sugAccItem.accno,
                        sno: sugAccItem.sno,
                        mem: '其他建議科目',
                    });
                });
            }

            return options;
        },
        async fetchAccountingItems() {
            this.accountingItems = [];

            const resp = await this.$api({
                url: 'Tool/GetAccountingSettings',
                method: 'GET',
            });
            if (resp) {
                this.accountingItems = [
                    ...resp.data.assetsSettings,
                    ...resp.data.liabilitiesSettings,
                    ...resp.data.shareholderSettings,
                    ...resp.data.revSettings,
                    ...resp.data.costSettings,
                    ...resp.data.oeSettings,
                    ...resp.data.norSettings,
                    ...resp.data.noeSettings,
                    ...resp.data.taxSettings,
                ];
            }
        },
        getStatementItemBySno(sno) {
            // 支出/收入項目不一定只會落在單一分類（例如支出項目可能是「營業支出」也可能是「財務資產支出」），
            // 因此比照 getHierarchyItemNames 的作法，掃描所有分類找出對應項目，避免因分類判斷錯誤而找不到項目
            const CHECK_TYPES = ['payoutSettings', 'invoiceSettings', 'cInSettings', 'cInElseSettings', 'cOutSettings', 'cOutElseSettings'];

            // eslint-disable-next-line no-restricted-syntax
            for (const checkType of CHECK_TYPES) {
                // eslint-disable-next-line no-restricted-syntax
                for (const parent of this.statementOptions[checkType] || []) {
                    // 先檢查大群組
                    if (parent.sno === sno) {
                        return parent;
                    }
                    // 再檢查子項目
                    if (Array.isArray(parent.childSettings)) {
                        const child = parent.childSettings.find((c) => c.sno === sno);
                        if (child) {
                            return child;
                        }
                    }
                }
            }
            return null; // 沒找到就回傳 null
        },
        getAccountingItemByAccno(accno) {
            return this.accountingItems.find((item) => item.accno === accno);
        },
        async onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (!valid) return;

                this.isSubmitting = true;
                this.submitedAccItem = this.getAccountingItemByAccno(this.form.accno); // 給UI暫存用

                try {
                    console.log('Submitting...');
                    await this.$api({
                        url: 'AccountingSummaryPage/UpdateAccno',
                        method: 'POST',
                        data: {
                            typ: this.typ,
                            unT_NBR: this.unT_NBR,
                            accno: this.form.accno,
                        },
                    });
                    this.isSubmited = true;
                } catch (e) {
                    console.error(e);
                } finally {
                    this.isSubmitting = false;
                }
            });
        },
        onRegenerateVouchers() {
            this.$emit('regenerate-vouchers'); // 觸發祖父層重新產生傳票
        },
        getHierarchyItemNames(itemNo) {
            const hierarchy = [null, null, null];

            const types = [
                { key: 'payoutSettings', name: '營業支出' },
                { key: 'invoiceSettings', name: '營業收入' },
                { key: 'cInSettings', name: '營業其他收入' },
                { key: 'cInElseSettings', name: '財務資產收入' },
                { key: 'cOutSettings', name: '營業其他支出' },
                { key: 'cOutElseSettings', name: '財務資產支出' },
            ];

            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for (const t in types) {
                const options = this.$store.getters['statement/statementUiOptions'][types[t].key];
                // eslint-disable-next-line no-restricted-syntax, guard-for-in
                for (const i in options) {
                    const lv1Item = options[i];
                    // eslint-disable-next-line no-restricted-syntax, guard-for-in
                    for (const j in lv1Item.childSettings) {
                        const lv2Item = lv1Item.childSettings[j];
                        if (lv2Item.sno === itemNo) {
                            hierarchy[0] = types[t].name;
                            hierarchy[1] = lv1Item.iteM_NAM;
                            hierarchy[2] = lv2Item.iteM_NAM;
                            break;
                        }
                    }
                }
            }

            return hierarchy.join(' / ');
        },
    },
};
</script>

<style lang="scss">
.payment-modify-accno-dialog {
    > .el-dialog {
        max-width: 460px;
    }
    .statement-item-name,
    .acc-item-name {
        font-size: 10.5pt;
        border: 1px solid #eee;
        line-height: 100%;
        padding: 10px 15px;
        background-color: #f4f4f4;
        border-radius: 4px;
    }
    .loading-text {
        font-size: 9pt;
        color: #888;
        padding: -5px 0 10px 0;
    }
}
.el-select-dropdown__item.accno-option {
    height: 65px;
    border-top: 1px solid #f4f4f4;

    &:first-child {
        border-top: none;
    }

    > .accno-text {
        line-height: 100%;
        font-size: 11pt;
        color: #333;
        padding: 15px 0 5px 0;
    }

    > .sub-text {
        font-size: 8.5pt;
        color: #aaa;
        line-height: 100%;
        padding: 5px 0 15px 0;
    }
}
</style>
